export default [
    // packages ordered by priority
    "PFPCS",
    "PFCS",
    "PFTT",
    "PFTTNL",
    "PFPTTF",
    "PFTTF",
    "PFP",
    "PF",
    "HS",
];
